import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getAnalytics(params = { range_type: 'realtime' }) {
  return request({
    url: ENDPOINT.ANALYTICS,
    method: 'get',
    params
  })
}
